export const SUSPENSE_REASON = Object.freeze({
  ClosedOrOwnershipChange: 'closed_or_ownership_change',
  LowRoi: 'low_roi',
  PricingFeesSensitivity: 'pricing_fees_sensitivity',
  MissingIntegrationsProductGaps: 'missing_integrations_product_gaps',
  PoorOnboardingActivation: 'poor_onboarding_activation',
  SupportDissatisfaction: 'support_dissatisfaction',
  SwitchedToCompetitor: 'switched_to_competitor',
  MarketingPerformanceDisappointment: 'marketing_performance_disappointment',
  WrongRegistrationData: 'wrong_registration_data',
});

export const SUSPENSE_COMPETITOR = Object.freeze({
  Allo: 'allo',
  Sides: 'sides',
  Ordersmart: 'ordersmart',
  RobinCook: 'robin_cook',
  Lightspeed: 'lightspeed',
  GastroMaster: 'gastro_master',
  Dish: 'dish',
  Other: 'other',
});
